export enum EasternMapType {
    Map = 1,
    Plate,
    None,
}



// WEBPACK FOOTER //
// ./src/models/EasternMapType.ts